
export const environment = {
    production: false,
    
    //  apiBaseUrl: 'http://localhost:4000/api/v1',
    apiBaseUrl: 'https://api.sonachandiwale.com/api/v1',
    fileUrl: 'https://api.sonachandiwale.com',
    featureToggle: {
        enableNewUI: false,
    },
}       